<template>
    <div>
        <Banner :banners="banners" show-overlay class="green"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper green">
            <h2 class="title text-center">川柳不息來集章</h2>
            <div class="detail-wrapper pt-3">
                <h3>現在活動</h3>
            </div>
            <ul>
                <li v-for="(l, index) in list" :key="index">
                    <a
                        href=""
                        class="d-block"
                        @click.prevent="goDetail('reward', l.collectionId)"
                    >
                        <div class="campaign-wrapper">
                            <div class="card-body">
                                <div class="title">{{l.name}}</div>
                                <div class="text text-center">
                                    活動期間:{{l.activityDate}}
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import { apiGetOpenApiCollections } from '@/plugin/api';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            list: [],
        };
    },
    async mounted() {
        this.setLoading(true);
        await this.query();
        this.setLoading(false);
    },
    methods: {
        goDetail(view, id) {
            this.$router.push(`/${view}/${id}`).catch(() => {});
        },
        query() {
            return apiGetOpenApiCollections().then((ret) => {
                if (ret.data?.success) {
                    this.list = ret.data.data;
                } else {
                    this.commonAlert(ret.data?.message);
                }
            }, this.errorHandler);
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
